module.exports = __webpack_public_path__ + "img/traitement4.b97dfad7.jpg";